import React from 'react';

const ContextMenuPopup = ({ isActive, onClose, contextMenuPopupProp }) => {
  const validOptions = contextMenuPopupProp.filter(ele => ele.can);

  return (
    <div className={`modal ${isActive ? 'is-active' : ''}`}>
      <div className="modal-background" onClick={onClose} />
      <div className="modal-content" style={{ width: '300px' }}>
        <div
          className="box has-background-white"
          style={{ padding: 0, borderRadius: '6px' }}
        >
          <div className="column is-full" style={{ padding: 0 }}>
            {validOptions.map(valOpt => (
              <div>
                <div
                  className="has-text-centered py-4 px-5"
                  style={{ cursor: 'pointer' }}
                  onClick={valOpt.callback}
                >
                  <span className="has-text-dark">{valOpt.title}</span>
                </div>
                <hr
                  className="my-0"
                  style={{ backgroundColor: '#dbdbdb', height: '1px' }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <button className="modal-close is-large" onClick={onClose} />
    </div>
  );
};

export default ContextMenuPopup;
